// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__35BG_","file":"styles_file__CKKrN"};